import React from "react";
import { Grid, Typography, Container, makeStyles, Theme } from "@material-ui/core";

const AnswerItem = ({ item }) => {
  const answerData = item?.data;
  const classes = useStyles()

  return (
    <Grid container direction="column" spacing={1}>
      <Grid item className={classes.answerHeader} >
        <Container>
          <Typography variant="caption">
            <Typography
              variant="body2"
              color="textSecondary"
              style={{ textTransform: "uppercase" }}
            >
              {answerData?.heading?.text}
            </Typography>
          </Typography>
        </Container>
      </Grid>
      <Grid item className={classes.answerHtml}>
        <Container>
          <div dangerouslySetInnerHTML={{ __html: answerData?.content?.html }} />
        </Container>
      </Grid>
    </Grid>
  );
}

export default AnswerItem

const useStyles = makeStyles((theme: Theme) => ({

  answerHeader: {
    margin: "16px 0 0 0"
  },
  answerHtml: {
    fontFamily: "Roboto",
    fontSize: "14px",
    margin: "-16px 0 0 0",

    '& a': {
      color: "#0050b3",
      textDecoration: "underline !important",
    }
  }

}));